import script from "./ShareholderSharesTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShareholderSharesTab.vue?vue&type=script&setup=true&lang=ts"

import "./ShareholderSharesTab.vue?vue&type=style&index=0&id=10d65854&scope=true&lang=postcss"

const __exports__ = script;

export default __exports__